import dayjs, { Dayjs } from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'

dayjs.extend(isoWeek)

export const getFilterDateRange = (selectedDate: Dayjs, mode: 'year' | 'month' | 'week' | 'day' = 'month') => {
  let start: string
  let end: string

  switch (mode) {
    case 'year':
      start = dayjs(selectedDate).startOf('year').format('YYYY.MM.DD')
      end = dayjs(selectedDate).endOf('year').format('YYYY.MM.DD')
      break
    case 'week':
      start = dayjs(selectedDate).startOf('isoWeek').format('YYYY.MM.DD')
      end = dayjs(selectedDate).endOf('isoWeek').format('YYYY.MM.DD')
      break
    case 'day':
      start = dayjs(selectedDate).startOf('day').format('YYYY.MM.DD')
      end = dayjs(selectedDate).endOf('day').format('YYYY.MM.DD')
      break
    case 'month':
    default:
      start = dayjs(selectedDate).startOf('month').format('YYYY.MM.DD')
      end = dayjs(selectedDate).endOf('month').format('YYYY.MM.DD')
      break
  }

  return `${start}-${end}`
}
